import React, { useContext, Suspense, useEffect } from 'react'
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  useLocation,
} from 'react-router-dom'
import TagManager from 'react-gtm-module'
import { I18nextProvider } from 'react-i18next'
import i18n from '../i18n'
import ReactGA from 'react-ga'
// import SignUp from 'Index/containers/Authentication/SignUp'
// import Dashboard from 'Index/containers/Dashboard/index'
// import BrandDashboard from 'Brands/containers/BrandDashboard'
// import JoinJazeel from 'Index/containers/Widgets/JoinJazeel/index'
// import UserShareLinks from 'Index/containers/Widgets/UserShareLinks/index'
// import Invitation from 'Index/containers/Widgets/Invitation/index'
// import Joining from 'Index/containers/Widgets/Joining/index'
import { JazeelContext } from 'Influencers/utils/JazeelContext'
import { ToastProvider } from 'react-toast-notifications'
// import PrivateRoute from 'Index/influencerComponents/PrivateRoute'
// import Authentication from 'Index/containers/Authentication/index'
// import Signup from 'Brands/containers/Authentication/Signup'
// import CompanyForm from 'Brands/containers/Authentication/CompanyForm'
// import Login from 'Brands/containers/Authentication/Login'
// import Landing from 'Brands/containers/Landing'
// import Campaign from 'Brands/containers/Campaign'
// import Milestones from 'Brands/containers/Milestones'
// import MilestonesProfile from 'Brands/containers/MilestonesProfile'
// import InfluencerDetails from 'Brands/containers/InfluencerDetails'
// import BrandAccount from 'Brands/containers/Authentication/BrandAccount'
// import AccountLogin from 'Brands/containers/Authentication/AccountLogin'
// import MobileLanding from 'Brands/containers/Landing/MobileLanding'
// import Payment from 'Brands/containers/Payment'
import ErrorBoundary from './ErrorBoundary'
import CampaignSystem from 'CampaignSystem'
const tagManagerArgs = {
  gtmId: 'GTM-MNQM7RG',
}
const injectGA = () => {
  if (typeof window == 'undefined') {
    return
  }
  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag('js', new Date())
  gtag('config', 'UA-176125221-1')
}
TagManager.initialize(tagManagerArgs)
function App() {
  const { auth, signupSuccess } = useContext(JazeelContext)
  // console.log('appAuth:', auth)
  // useEffect(() => {
  //   // injectGA()
  //   ReactGA.initialize('UA-176125221-1')
  //   //ReactGA.pageview('/homepage')
  // }, [])
  // const location = useLocation();
  // useEffect(
  //   () => {
  //     ReactGA.send(['pageview', location.pathname])
  //   },
  //   [location]
  // )
  return (
    <ErrorBoundary>
      <ToastProvider>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter>
            <Switch>
              {/*<Route exact path="/signup">*/}
              {/*  {signupSuccess ? <Redirect to="/dashboard" /> : <SignUp />}*/}
              {/*</Route>*/}
              {/*<Route exact path="/login" component={Authentication} />*/}
              {/*<PrivateRoute path="/dashboard" component={Dashboard} />*/}
              {/*<Route path="/embedded" component={JoinJazeel} />*/}
              {/*<Route path="/sh" component={UserShareLinks} />*/}
              {/*<Route path="/invitation" component={Invitation} />*/}
              {/*<Route path="/join" component={Joining} />*/}
              {/*<Route exact path="/brands" component={Signup} />*/}
              {/*<Route exact path="/brands/dashboard" component={BrandDashboard} />*/}
              {/*<Route exact path="/brands/profile" component={CompanyForm} />*/}
              {/*<Route exact path="/brands/milestones" component={Milestones} />*/}
              {/*<Route*/}
              {/*  exact*/}
              {/*  path="/brands/milestones/profile"*/}
              {/*  component={MilestonesProfile}*/}
              {/*/>*/}
              {/*<Route exact path="/brands/login" component={Login} />*/}
              {/*<Route exact path="/brands/signup" component={BrandAccount} />*/}
              {/*<Route exact path="/brands/signin" component={AccountLogin} />*/}
              {/* need to handle */}
              {/*<Route path="/brands/landing" component={Landing} />*/}
              {/*<Route path="/brands/campaign" component={Campaign} />*/}
              {/*<Route path="/brands/influencer" component={InfluencerDetails} />*/}
              {/*<Route path="/" component={MobileLanding} />*/}
              <Route path="/" component={CampaignSystem} />
              {/*<Route path="/payment" component={Payment} />*/}
              {/*<Route path="/" component={Landing} />*/}
              {/*<Route path="/">*/}
              {/*  {signupSuccess ? (*/}
              {/*    <Redirect to="/dashboard" />*/}
              {/*  ) : (*/}
              {/*    <Authentication />*/}
              {/*  )}*/}
              {/*</Route>*/}
              <Route path="*" component={() => '404 NOT FOUND'} />
            </Switch>
          </BrowserRouter>
        </I18nextProvider>
      </ToastProvider>
    </ErrorBoundary>
  )
}

export default App
